import React from "react";
import { downloadDocument } from "../../../utils/API/downloadDocument";
import Button from "../Button";
import toast from "react-hot-toast";
const DownloadButton = ({ fileUrl }) => {

  const downloadFile = async () => {
    try {

      const key = fileUrl.split("/customertenants/")[1];
      const fileName = key.split("/").pop();

      let blob = await downloadDocument(key);

      const url = window.URL.createObjectURL(new Blob([blob]));

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("download file ", error);
    }
  };

  return (
    <Button
      color="blue"
      varient="secondary"
      className="text-white bg-blue-800 rounded font-normal flex justify-center items-center px-3 text-xs"
      onClick={downloadFile}
    >
      Download
    </Button>
  );
};

export default DownloadButton;
